import React, { PureComponent } from 'react'
import Dialog from 'material-ui/Dialog'
import TextField from 'material-ui/TextField'
import RaisedButton from 'material-ui/RaisedButton'
import FlatButton from 'material-ui/FlatButton'
import SearchItemList from './SearchItemList'
import OwnedForm from '../OwnedForm'
import { getObjectConditions } from '../../utils'
import { themeColors } from '../../styles/theme'

import ReactModal from 'react-modal'
import Close from 'material-ui/svg-icons/navigation/close'
import IconButton from 'material-ui/IconButton'

const modalStyles = {
  header: {
    height: 52,
    backgroundColor: themeColors.positive,
    color: themeColors.white,
    display: 'flex',
    alignItems: 'center',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 111111,
  },
  footer: {
    height: 50,
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: themeColors.lightBackground,
    color: themeColors.white,
    display: 'flex',
    alignItems: 'center',
  },
  scrolling: {
    paddingTop: 60,
    overflow: 'scroll',
  },
  paddingScroll: {
    padding: 5,
    paddingTop: 60,
    overflow: 'scroll',
    zIndex: 111111,
  },
}

class SearchForItem extends PureComponent {
  state = {
    modalSearchOpen: false,
    ownedFormOpen: false,
    item: null,
    searchString: '',
  }

  handleOnChangeSearch = e => this.setState({ searchString: e.target.value })

  handleOnItemSelected = item => {
    this.setState({
      item,
      modalSearchOpen: false,
      ownedFormOpen: true,
    })
  }

  handleCloseModal = () => this.setState({ modalSearchOpen: false })

  handleCloseModalOwned = () => this.setState({ modalSearchOpen: true, ownedFormOpen: false })

  handleSubmit = e => {
    e.preventDefault()
    this.setState({ modalSearchOpen: true })
  }

  render() {
    const {
      category,
      onDismiss,
      onSubmitOwned,
      onSubmitOwnedSuccess,
    } = this.props

    const actions = [
      <FlatButton label="Inseriscilo tu" primary={true} onClick={onDismiss} />,
    ]

    return (
      <form onSubmit={this.handleSubmit}>
        <TextField
          hintText="Cerca"
          onChange={this.handleOnChangeSearch}
          value={this.state.searchString}
          floatingLabelText="Cerca"
          fullWidth={true}
        />

        <ReactModal
          actions={actions}
          isOpen={this.state.modalSearchOpen}
          onRequestClose={this.handleCloseModal}
          contentLabel="Ricerca oggetto"
          style={{
            overlay: {
              zIndex: 111111,
            },
            content: {
              position: 'fixed',
              top: '0px',
              bottom: '0px',
              left: '0px',
              right: '0px',
              padding: 0,
            },
          }}>
          <div style={modalStyles.header}>
            <IconButton
              onClick={this.handleCloseModal}
              iconStyle={{ color: themeColors.white }}>
              <Close />
            </IconButton>
            <span>{`${category.nome} "${this.state.searchString}"`}</span>
          </div>
          <div style={modalStyles.scrolling}>
            <SearchItemList
              category={category}
              onItemSelected={this.handleOnItemSelected}
              searchString={this.state.searchString}
            />
          </div>
          <div style={modalStyles.footer}>
            <FlatButton
              label="Inseriscilo tu"
              primary={true}
              onClick={onDismiss}
            />
          </div>
        </ReactModal>

        <ReactModal
          actions={actions}
          isOpen={this.state.ownedFormOpen}
          onRequestClose={this.handleCloseModalOwned}
          contentLabel="Aggiungi a possiedo"
          style={{
            overlay: {
              zIndex: 1111,
            },
            content: {
              position: 'fixed',
              top: '0px',
              bottom: '0px',
              left: '0px',
              right: '0px',
              padding: 0,
            },
          }}>
          <div style={modalStyles.header}>
            <IconButton
              onClick={this.handleCloseModalOwned}
              iconStyle={{ color: themeColors.white }}>
              <Close />
            </IconButton>
            <span>{`${category.nome} "${this.state.searchString}"`}</span>
          </div>
          <div style={modalStyles.paddingScroll}>
            <OwnedForm
              item={this.state.item}
              toggleOpen={this.handleCloseModalOwned}
              conditions={getObjectConditions(category.id)}
              onSubmit={conditions =>
              onSubmitOwned(this.state.item, conditions)}
              onSubmitSuccess={onSubmitOwnedSuccess}
            />
          </div>
        </ReactModal>

        <div style={{ display: 'flex' }}>
          <div style={{ marginTop: 40, marginLeft: 'auto' }}>
            <RaisedButton type="submit" primary={true} label="Cerca" />
          </div>
        </div>
      </form>
    )
  }
}

export default SearchForItem



// WEBPACK FOOTER //
// ./src/common/AddItemForm/SearchForItem.js